import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "disabled", "sx", "required", "validationStatus", "rows", "cols", "resize", "block"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import styled, { css } from 'styled-components';
import React from 'react';
import { TextInputBaseWrapper } from './_TextInputWrapper';
import sx from './sx';
var StyledTextarea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextarea",
  componentId: "sc-wz5skc-0"
})(["border:0;font-size:inherit;font-family:inherit;background-color:transparent;-webkit-appearance:none;color:inherit;width:100%;resize:both;&:focus{outline:0;}", " ", " ", ";"], function (props) {
  return props.resize && css(["resize:", ";"], props.resize);
}, function (props) {
  return props.disabled && css(["resize:none;"]);
}, sx);
/**
 * An accessible, native textarea component that supports validation states.
 * This component accepts all native HTML <textarea> attributes as props.
 */

var Textarea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      sxProp = _ref.sx,
      required = _ref.required,
      validationStatus = _ref.validationStatus,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 7 : _ref$rows,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 30 : _ref$cols,
      _ref$resize = _ref.resize,
      resize = _ref$resize === void 0 ? 'both' : _ref$resize,
      block = _ref.block,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TextInputBaseWrapper, {
    sx: sxProp,
    validationStatus: validationStatus,
    disabled: disabled,
    block: block
  }, /*#__PURE__*/React.createElement(StyledTextarea, _extends({
    value: value,
    resize: resize,
    required: required,
    "aria-required": required ? 'true' : 'false',
    "aria-invalid": validationStatus === 'error' ? 'true' : 'false',
    ref: ref,
    disabled: disabled,
    rows: rows,
    cols: cols
  }, rest)));
});
Textarea.displayName = 'Textarea';
export default Textarea;